import bootstrapData from './composer/utils/bootstrapData';
import { i18nFeatureFlagName, initI18n } from '../i18n/i18n';
import initSentry from './sentry/initSentry';
import { initialize as initTracking } from '../tracking/dataLayer';

function injectCsrfTokenToHtml(csrfToken: string) {
  const csrfParamElement = document.createElement('meta');
  csrfParamElement.name = 'csrf-param';
  csrfParamElement.content = 'authenticity_token';
  const csrfTokenElement = document.createElement('meta');
  csrfTokenElement.name = 'csrf-token';
  csrfTokenElement.content = csrfToken;
  document.head.append(csrfParamElement, csrfTokenElement);
}

function getNavigatorLanguage() {
  return typeof navigator !== 'undefined' ? navigator.language : undefined;
}

async function bootstrap() {
  const data = await bootstrapData();
  /* Injecting this still to HTML because e2e tests will use it */
  injectCsrfTokenToHtml(data.csrf_token);
  if (data.sentry_dsn) {
    initSentry({
      dsn: data.sentry_dsn,
      environment: data.environment,
      userId: data.user_id_for_sentry,
      tenantId: data.tenant_id,
    });
  }
  if (data.enabled_features.includes(i18nFeatureFlagName)) {
    const language = data.user_preferences?.language || getNavigatorLanguage();
    initI18n(language);
  } else {
    initI18n();
  }
  initTracking(data.enabled_features.includes('adobeTracking'));
}

bootstrap();
